import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, ValidatorFn } from '@angular/forms';
import { Agent, ApiAgentInformation, CreditAgentFormData } from '../../models';
import { AgentCodeTypeaheadService } from '../../index';

@Component({
    selector: 'credit-agent-panel',
    template: require('./credit-agent-panel.component.html')
})
export class CreditAgentPanelComponent extends OnInit {
    @Input() agent: Agent;
    @Input() creditAgentFormData: CreditAgentFormData;

    // showAgentHelp only displays once when you first enter the page
    public showAgentHelp: boolean = true;

    public showGiveCredit: boolean = false;
    public showCreditAgentPanel: boolean = true;
    public showAgentSearch: boolean = false;
    public showComplete: boolean = false;
    public hasErrors: boolean = false;
    public submitted: boolean = false;

    public form: FormGroup;
    public agentInfo: FormControl;

    // agent name is used for display only
    public agentDisplayValue: string;
    private closeCompleteTimer: number;
    private existingAgentCode;
    private validationMessages: any = {
        'agentInfo': {
            'required': 'Agent Name or ID is required to give credit to your agent.'
        }
    };

    constructor (private agentCodeSearchService: AgentCodeTypeaheadService) {
        super();
    }

    public ngOnInit(): void {
        // builds the form
        this.form = new FormGroup({});
        let agentValidators: ValidatorFn[] = [Validators.required];
        this.agentInfo = new FormControl(this.creditAgentFormData.agentCode, Validators.compose(agentValidators));
        this.form.addControl('agentInfo', this.agentInfo);

        // if there an existing agent being credited passed in already, don't show credit agent panel
        if (this.creditAgentFormData && this.creditAgentFormData.agentCode && this.creditAgentFormData.agencyCode) {
            this.showCreditAgentPanel = false;
            this.populatePassedInAgent();
        }
        else if (this.agent) {
            this.existingAgentCode = this.agent.agentCode;
        }
    }

    public get isAgentSelected(): boolean {
        return this.agentInfo && this.agentInfo.valid;
    }

    public agentHelped(): void {
        this.showAgentHelp = false;
        this.showAgentSearch = true;
    }

    public openCreditAgentPanel(): void {
        this.showCreditAgentPanel = true;
        this.showAgentSearch = true;
        this.showGiveCredit = false;
    }

    public collapseCreditAgentPanel(): void {
        this.showCreditAgentPanel = false;
        this.showAgentSearch = false;
        this.showAgentHelp = false;
        this.showGiveCredit = true;

        // reset the form when the panel is collapsed it it wasn't valid before
        if (!this.form.valid) {
            this.resetForm();
        }
    }

    public closeComplete(): void {
        this.showComplete = false;

        // clears out the timer if it hasn't fired yet
        if (this.closeCompleteTimer) {
            clearTimeout(this.closeCompleteTimer);
        }
    }

    public cancelAgentCredit(): void {
        this.resetForm();
    }

    public populatePassedInAgent(): void {
        // Since we have an existing agent passed in, don't show search, just a confirmation that credit will be given to the selected agent
        if (this.agent) {
            this.agentCodeSearchService.search(this.creditAgentFormData.agentCode)
            .subscribe((agents: ApiAgentInformation[]) => {
                let matchedAgent: ApiAgentInformation = agents.find((agent: ApiAgentInformation) => {
                    return agent.agentCode === this.creditAgentFormData.agentCode;
                });

                if (matchedAgent) {
                    this.agentInfo.setValue(matchedAgent);
                    this.existingAgentCode = matchedAgent.agentCode;
                    this.giveAgentCredit(false);
                }
            });
        }
    }

    public giveAgentCredit(fadeAwayReviewPanel: boolean = true): void {
        this.submitted = true;
        this.hasErrors = !this.form.valid;

        if (this.form.valid && this.agentInfo && this.agentInfo.value) {
            // lock in the agent as being credited
            this.showCreditAgentPanel = false;
            this.showAgentSearch = false;
            this.showComplete = true;

            this.creditAgentFormData.agentCode = this.agentInfo.value.agentCode;
            this.creditAgentFormData.agencyCode = this.agentInfo.value.agencyCode;

            if (fadeAwayReviewPanel) {
                // close the 'thanks' panel after 5 secounds
                this.closeCompleteTimer = window.setTimeout(() => {
                    this.showComplete = false;
                }, 5000);
            }
        }
    }

    public onAgentSelected(selectedAgent: ApiAgentInformation, selectedFrom : string): void {
        // update the agent info value so that both typeaheads are updated
        this.agentInfo.setValue(selectedAgent);
        if(selectedFrom === "code"){
            this.agentDisplayValue = selectedAgent.agentCode;
        }else if(selectedFrom === "name"){
            this.agentDisplayValue = selectedAgent.agentName;
        }
        this.submitted = true;
        this.hasErrors = !this.form.valid;
    }

    private resetForm(): void {
        // clears out the agent info, resets the errors
        this.agentInfo.setValue(null);
        this.submitted = false;
        this.hasErrors = false;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/components/agents/credit-agent-panel.component.ts